import { SET_IS_FORM_SENDING } from './actions';

export const initialState = {
	isFormSending: false,
};

const termsContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_IS_FORM_SENDING:
			return {
				...state,
				isFormSending: payload,
			};
		default:
			return state;
	}
};

export default termsContainerReducer;
